import React from "react";
import { useParams } from "react-router-dom";
import MgtForm from "./MgtForm";
import MgtTwoForm from "./MgtTwoForm";
import RegisterDirAndKmpForm from "./RegisterDirAndKmpForm";
import ShTenForm from "./ShTenForm";
import ShTwoForm from "./ShTwoForm";
import ShSixForm from "./ShSixForm";
import ShThreeForm from "./ShThreeForm";
import ChgSevenForm from "./ChgSevenForm";
import MbpTwoForm from "./MbpTwoForm";
import MbpThreeForm from "./MbpThreeForm";
import MbpFourForm from "./MbpFourForm";
// import others as needed

const RegisterFormRouter = () => {
  const { id } = useParams();

  const formMap = {
    "1": <MgtForm />,
      "2": <MgtTwoForm />,
    "3": <RegisterDirAndKmpForm />,
    "4": <ShTwoForm />,
    "5": <ShThreeForm />,
    "6": <ShSixForm />,
    "7": <ShTenForm />,
    "8": <ChgSevenForm />,
    "9": <MbpTwoForm />,
    "10": <MbpThreeForm />,
    "11": <MbpFourForm />,
  };

  return (
    <div>
      {formMap[id] || (
        <div className="text-red-600 font-semibold">
          Form not implemented yet
        </div>
      )}
    </div>
  );
};

export default RegisterFormRouter;
